export const DEDUP_INTERVAL_DEFAULT = 5000;
export const DEDUP_INTERVAL_AUTOCOMPLETE = 10000;
export const DEDUP_INTERVAL_AUTOCOMPLETE_SUGGESTION = 60000;
export const DEDUP_INTERVAL_TICKET_FILTERS = 10000;
export const DEDUP_INTERVAL_USER_FILTERS = 10000;

export const REFRESH_INTERVAL_DEFAULT = 5000;
export const REFRESH_INTERVAL_CHAT_QUEUE = 5000;
export const REFRESH_INTERVAL_MINE_RECENT_TICKETS = 30000;
export const REFRESH_INTERVAL_CHAT_ENTITIES = REFRESH_INTERVAL_DEFAULT;
export const REFRESH_INTERVAL_BULK_TICKET_CHANGE_JOB_LIST = 3000;
